import { useAuthStore } from '@/stores/auth.js'

export default {
  computed: {
    loggedInUser() {
      return useAuthStore().currentUser
    }
  }
}
